// modules
import { addModal, closeCurrentModal } from 'weblite-web-modal-viewer'
// component
import { ChatListMenu } from './chat-list-menu'
import { RoomList } from '$logic/room-list/room-list.react-hook'
import { exitRoomListFromSelectionMode } from '$logic/router'

const COMPONENT_ID = 'chatListMenu'

interface Prop {
  chatItems: RoomList[]
}

export const showChatListMenu = (props: Prop, preventBackClick = false) =>
  addModal({
    id: COMPONENT_ID,
    props: {
      ...props,
      onClose: async () => {
        await closeCurrentModal()
        exitRoomListFromSelectionMode()
      },
    },
    preventBackClick,
  })

export default {
  [COMPONENT_ID]: { Component: ChatListMenu },
}
